<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" scrollable max-width="300px">
        <v-card>
          <v-card-title>Selecione a situação</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-radio-group v-model="situacao" column>
              <v-radio
                color="primary"
                label="Aguardando"
                :value="aguardando"
              ></v-radio>
              <v-radio
                color="success"
                label="Enviado"
                value="Enviado"
              ></v-radio>
              <v-radio
                color="red"
                label="Erro"
                value="Error"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click="confirm(situacao)">Salvar</v-btn>
            <v-btn color="primary" outlined @click="cancel">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "ModalSituação",
  data() {
    return {
      situacao: null,
      resolve: null,
      reject: null,
      dialog: false,
      aguardando: null,
    };
  },
  methods: {
    open() {
      return new Promise((resolve, reject) => {
        this.dialog = true;
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel() {
      this.reject();
      this.close();
    },
    async confirm(situacao) {
      this.resolve(situacao);
      this.close();
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
